import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import BuildIcon from '@material-ui/icons/BuildRounded';
import { useHistory } from 'react-router-dom';

export default function SiteAdminButton() {
  const history = useHistory();

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    history.push('/main/site-admin');
  };

  return (
    <IconButton style={{ padding: '4px' }} onClick={handleClick}>
      <BuildIcon style={{ height: '21px', color: '#7A797A' }} />
      <span style={{ position: 'absolute', fontSize: '12px', top: 23 }}>SITE</span>
    </IconButton>
  );
}
